import { DOM } from '../core/dom';

const controls = ['faq-recruitment', 'faq-legal', 'faq-gigs', 'faq-work'];

export namespace FAQ {
  export function setup(): void {
    for (const control of controls) {
      DOM.onIdClick(control, (_, elem) => {
        DOM.removeClass('.faq-control, .faq-section', 'active');
        elem.classList.add('active');
        DOM.byId(control + '-content').classList.add('active');
      });
    }
    DOM.onMatchClick('.faq-item-question', (_, elem) => {
      const answerElem = elem.nextElementSibling;
      if (answerElem.classList.contains('active')) {
        elem.children.item(0).innerHTML = '+';
        answerElem.classList.remove('active');
      } else {
        elem.children.item(0).innerHTML = '-';
        answerElem.classList.add('active');
      }
    });
  }
}